webpackJsonp([24],{

/***/ 1052:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error404_vue__ = __webpack_require__(1105);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469ae63a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error404_vue__ = __webpack_require__(1177);
var normalizeComponent = __webpack_require__(24)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_error404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_469ae63a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_error404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1105:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_slick__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helper_internet_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "homepage",
  components: { Slick: __WEBPACK_IMPORTED_MODULE_0_vue_slick__["default"] },
  metaInfo: {
    title: "perfect",
    titleTemplate: null
  },
  data: function data() {
    return {
      msg: "Welcome to Your 404 Page",
      slickOptions: {
        slidesToShow: 3
      },
      shows: {}
    };
  },
  beforeMount: function beforeMount() {
    // this.getNowShowingData();
  },

  methods: {
    getNowShowingData: function getNowShowingData() {
      var _this = this;

      var payload = {};
      // console.log('test2', this.dropDowns.cinemaChain.selected)
      // if(this.dropDowns.cinemaChain.selected.OrganizationName != 'All Cinemas'){
      // console.log('test3', this.dropDowns.cinemaChain.selected)
      //     payload.organisationID = this.dropDowns.cinemaChain.selected.OrganisationID;
      // }
      // if(this.dropDowns.languages.selected.Title != 'All Languages'){
      //     payload.language = this.dropDowns.languages.selected.Title;
      // };
      // if(this.$persistStore.get("accessToken")){
      //     payload.accessToken = this.$persistStore.get("accessToken");
      // };

      // payload.CountryID = this.getCountryFromLocalStorage().CountryID;
      payload.CountryID = 5;
      payload.LanguageID = 1;
      Object(__WEBPACK_IMPORTED_MODULE_1__helper_internet_js__["makeRequestDirect"])("/GetAllShow", "POST", null, payload).then(function (response) {
        var error = response.error,
            res = response.res;

        console.log("movie", error, res);
        if (!error && res.data.Status) {
          var data = res.data.data;

          var arr = [];
          console.log("t3", res);
          _this.shows = res.data;
          res.data.shows.map(function (x) {
            // x.Movies.map(function(y,_index){
            //     y['url'] =  "/movie-details-page?movieId=" + y.ID;
            //     y['bookingURL'] =  "/movie-details-page?movieId=" + y.ID + '&timing=1';
            // })
          });

          //                         this.banners = res.data.Banner;
          //                         console.log('banners',this.banners)
          // //                      for(let movie in res.data.shows[0]){
          // //                          console.log()
          // //                          movie["url"] = "/movie-details-page?movieId=" + movie.ID;
          // //                        arr.push(movie);
          // //                      }
          //                       this.nowShowing = res.data.shows[0];
          //                       this.comingSoon = res.data.shows[1];
          //                       this.artHouse = res.data.shows[2];
          //                       if(this.movieFilterValue == 'Now Showing'){
          //                           this.listingMovies = res.data.shows[0];
          //                       }else if(this.movieFilterValue == 'Coming Soon'){
          //                       this.listingMovies = res.data.shows[1];
          //                       } else{
          //                       this.listingMovies = res.data.shows[2];
          //                       }
          // //                      console.log(arr);
          // //                      this.nowShowing = arr;
          // //                      this.slides.nowShowing =
          // //                          typeof data.nowShowing[0] !== undefined &&
          // //                          Object.keys(data.nowShowing[0]).length > 0
          // //                              ? data.nowShowing[0]
          //                              : null;
          // console.log("Data >>>", this.slides);
        } else {
          console.log("Response Error ");
        }
      }).catch(function (error) {
        console.log("Error", error);
      });
    }
  }
});

/***/ }),

/***/ 1177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center align-items-center error-container mt-5"},[_c('div',{staticClass:"text-center"},[_c('img',{staticClass:"error_img",attrs:{"src":__webpack_require__(1178)}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"text-center mt-4"},[_c('router-link',{staticClass:"retry-btn",attrs:{"to":"/"}},[_vm._v("Click To Go to Our Home Page")])],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-text"},[_c('p',[_vm._v("Uh-oh!")]),_vm._v(" "),_c('p',[_vm._v("You are in a no-man’s-land!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1178:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/wanasa 404.60218a0.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/24.6b11a6bf0ee1e290c943.js